import {
	DataGridPro,
	GridToolbarColumnsButton,
	GridToolbarDensitySelector,
	GridToolbarExport,
	GridToolbarFilterButton,
} from "@mui/x-data-grid-pro";
import Box from "@mui/material/Box";
import React from "react";
import { GridToolbarContainer, GridToolbarQuickFilter } from "@mui/x-data-grid";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import DeleteConfirmationDialog from "../Dialogs/DeleteConfirmationDialog";

const CustomToolbar = ({ chosenCategories, isAdmin, handleDeleteItems }) => {
	return (
		<GridToolbarContainer>
			<Box sx={{ display: "flex", gap: 1 }}>
				{isAdmin && !chosenCategories?.length > 0 && (
					<>
						<GridToolbarFilterButton />
						<GridToolbarColumnsButton />
						<GridToolbarDensitySelector />
						<GridToolbarExport />
					</>
				)}

				{chosenCategories && chosenCategories?.length > 0 && (
					<DeleteConfirmationDialog
						header="Delete Confirmation"
						title="Are you sure you want to delete these categories?"
						description="This will remove the categories from any products and quote templates."
						response={() => handleDeleteItems()}
					>
						{(showDialog) => (
							<Tooltip
								title='Delete'
								arrow
								sx={{ py: 0 }}
							>
								<IconButton
									color='error'
									onClick={showDialog}
								>
									<DeleteIcon fontSize={"small"} />
								</IconButton>
							</Tooltip>
						)}
					</DeleteConfirmationDialog>
				)}
			</Box>

			<Box sx={{ marginLeft: "auto" }}>
				<GridToolbarQuickFilter />
			</Box>
		</GridToolbarContainer>
	);
};

const ExistingCategoriesDataGrid = ({
	categories,
	setCategory,
	loading,
	chosenCategories,
	columns,
	isAdmin,
	rowModesModel,
	handleRowModesModelChange,
	setRows,
	setRowModesModel,
	handleDeleteItems,
}) => {
	return (
		<Box
			sx={{
				"& .new-param-theme--header": {
					color: "white",
				},
				height: 500,
			}}
		>
			<DataGridPro
				columns={columns}
				rows={categories}
				rowModesModel={rowModesModel}
				onRowModesModelChange={handleRowModesModelChange}
				onRowSelectionModelChange={(newRowSelectionModel) => {
					setCategory(newRowSelectionModel);
				}}
				slots={{
					toolbar: CustomToolbar,
				}}
				initialState={{
					density: 'compact',
				}}
				checkboxSelection
				loading={!!loading}
				slotProps={{
					toolbar: {
						setRows,
						setRowModesModel,
						handleDeleteItems,
						chosenCategories,
						isAdmin,
						csvOptions: {
							disableToolbarButton: !isAdmin,
						},
						printOptions: {
							disableToolbarButton: !isAdmin,
						},
						showQuickFilter: true,
					},
					loadingOverlay: {
						variant: "skeleton",
						noRowsVariant: "skeleton",
					},
				}}
			/>
		</Box>
	);
};

export default ExistingCategoriesDataGrid;
